// Super admins start on the Organizations page (the impersonation chooser) rather
// than the member-facing org selector. The selector's "auto-enter single org"
// behavior is for regular admins/owners only.
export const shouldRedirectSuperAdminToOrganizations = (
  toName: string | null | undefined,
  isSuperAdmin: boolean,
): boolean => toName === 'orgSelector' && isSuperAdmin
